import React from 'react';
import logofooter from '../src/assets/logo_multicare.svg';
import { FaShieldAlt, FaPercent, FaStethoscope, FaPhoneAlt } from 'react-icons/fa'; // Ícones para a primeira seção
import { TiArrowUpOutline } from "react-icons/ti";
function Footer() {
  return (
    <footer>
      {/* Primeira Seção com um div ocupando 100% da largura */}

    <div className="w-full bg-[#F0F1F3] py-12 px-6  ">


      <button
  type="submit"
  className="conversion-btn flex items-center mx-auto"
  onClick={() => document.getElementById('askproposal').scrollIntoView({ behavior: 'smooth' })}
>
  <TiArrowUpOutline className="mr-2" />
  Quer saber mais? 
</button>



                                        </div>
                                        <div style={{ marginBottom: '40px' }}></div>



     

      {/* Segunda Seção com logo e texto */}
      <section className="footer-info">
        <div className="footer-container">
          <div className="footer-logo">
     
<img
  src={logofooter}
  alt="Logo"
  className="my-2 mx-auto max-w-[80px] md:max-w-[200px] lg:max-w-[240px] lg:left-1/2 lg:transform lg:-translate-x-1/2"
/>

          </div>

          <div style={{ textAlign: 'center' }} className="block lg:hidden">
  <button
    type="submit"
     className="conversion-btn flex items-center mx-auto"
    onClick={() => document.getElementById('askproposal').scrollIntoView({ behavior: 'smooth' })}
  >
    <TiArrowUpOutline className="mr-2" />
    Pedir a sua simulação!
  
  </button>
</div>

          <div className="footer-text">
            <p>
              * Prémio total para fracionamento mensal, aplicável durante a 1ª anuidade, para uma pessoa de 30 anos que subscreva o seguro Multicare 1. 
            <br></br>Campanha válida para subscrição de um seguro de saúde Multicare até 31 de dezembro 2025.
              <br></br>Esta informação não dispensa a consulta da informação pré-contratual e contratual legalmente exigida.
 

              <br></br>
              Fidelidade - Companhia de Seguros, S.A.- NIPC e Matrícula 500 918 880, na CRC Lisboa - Sede: Largo do Calhariz, 30 1249-001 Lisboa – Portugal - Capital Social EUR 509.263.524<br />
              Apoio ao Cliente: Dias úteis das 9h às 20h. Assistência: todos os dias 24h/dia - T. 217 948 880 Chamada para a rede fixa nacional. E. <a href="mailto:apoiocliente@multicare.pt">apoiocliente@multicare.pt</a> . <a href="https://www.multicare.pt" target="_blank" rel="noopener noreferrer">www.multicare.pt</a>
            </p>
          </div>
        </div>
      </section>
    </footer>
  );
}

export default Footer;
